/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { DashboardHandlingUnitType } from "./DashboardHandlingUnitType";
import {
  DashboardHandlingUnitTypeFromJSON,
  DashboardHandlingUnitTypeFromJSONTyped,
  DashboardHandlingUnitTypeToJSON,
  DashboardHandlingUnitTypeToJSONTyped,
} from "./DashboardHandlingUnitType";

/**
 *
 * @export
 * @interface DimensionReportLineItem
 */
export interface DimensionReportLineItem {
  /**
   *
   * @type {string}
   * @memberof DimensionReportLineItem
   */
  description: string;
  /**
   *
   * @type {number}
   * @memberof DimensionReportLineItem
   */
  numberHandlingUnits: number;
  /**
   *
   * @type {DashboardHandlingUnitType}
   * @memberof DimensionReportLineItem
   */
  handlingUnitType: DashboardHandlingUnitType;
  /**
   *
   * @type {number}
   * @memberof DimensionReportLineItem
   */
  totalWeight: number;
  /**
   *
   * @type {number}
   * @memberof DimensionReportLineItem
   */
  length: number;
  /**
   *
   * @type {number}
   * @memberof DimensionReportLineItem
   */
  width: number;
  /**
   *
   * @type {number}
   * @memberof DimensionReportLineItem
   */
  height: number;
}

/**
 * Check if a given object implements the DimensionReportLineItem interface.
 */
export function instanceOfDimensionReportLineItem(
  value: object,
): value is DimensionReportLineItem {
  if (!("description" in value) || value["description"] === undefined)
    return false;
  if (
    !("numberHandlingUnits" in value) ||
    value["numberHandlingUnits"] === undefined
  )
    return false;
  if (!("handlingUnitType" in value) || value["handlingUnitType"] === undefined)
    return false;
  if (!("totalWeight" in value) || value["totalWeight"] === undefined)
    return false;
  if (!("length" in value) || value["length"] === undefined) return false;
  if (!("width" in value) || value["width"] === undefined) return false;
  if (!("height" in value) || value["height"] === undefined) return false;
  return true;
}

export function DimensionReportLineItemFromJSON(
  json: any,
): DimensionReportLineItem {
  return DimensionReportLineItemFromJSONTyped(json, false);
}

export function DimensionReportLineItemFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): DimensionReportLineItem {
  if (json == null) {
    return json;
  }
  return {
    description: json["description"],
    numberHandlingUnits: json["numberHandlingUnits"],
    handlingUnitType: DashboardHandlingUnitTypeFromJSON(
      json["handlingUnitType"],
    ),
    totalWeight: json["totalWeight"],
    length: json["length"],
    width: json["width"],
    height: json["height"],
  };
}

export function DimensionReportLineItemToJSON(
  json: any,
): DimensionReportLineItem {
  return DimensionReportLineItemToJSONTyped(json, false);
}

export function DimensionReportLineItemToJSONTyped(
  value?: DimensionReportLineItem | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    description: value["description"],
    numberHandlingUnits: value["numberHandlingUnits"],
    handlingUnitType: DashboardHandlingUnitTypeToJSON(
      value["handlingUnitType"],
    ),
    totalWeight: value["totalWeight"],
    length: value["length"],
    width: value["width"],
    height: value["height"],
  };
}
